import { getData, postData, deleteData } from "../../api";

export const getAllData = async (
  page,
  per_page,
  search,
  name,
  from,
  to,
  state_id,
  city_id,
  bank_account_id,
) => {
  try {
    let url = `/payment/inward-payment?dum=a`;

    if (page) {
      url += `&page=${page}`;
    }

    if (per_page) {
      url += `&per_page=${per_page}`;
    }

    if (search) {
      url += `&term=${search}`;
    }

    if (name) {
      url += `&name=${name}`;
    }

    if (from) {
      url += `&from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    if (state_id) {
      url += `&state_id=${state_id}`;
    }

    if (city_id) {
      url += `&city_id=${city_id}`;
    }

    if (bank_account_id) {
      url += `&bank_account_id=${bank_account_id}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const getAllReportsData = async (
  page,
  per_page,
  search,
  name,
  from,
  to,
  state_id,
  city_id,
  bank_account_id,
) => {
  try {
    let url = `/payment/inward-payment/reports?`;

    if (page) {
      url += `&page=${page}`;
    }

    if (per_page) {
      url += `&per_page=${per_page}`;
    }

    if (search) {
      url += `&term=${search}`;
    }

    if (name) {
      url += `&name=${name}`;
    }

    if (from) {
      url += `&from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    if (state_id) {
      url += `&state_id=${state_id}`;
    }

    if (city_id) {
      url += `&city_id=${city_id}`;
    }

    if (bank_account_id) {
      url += `&bank_account_id=${bank_account_id}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const getBankPaymentsData = async (
  page,
  per_page,
  search,
  name,
  from,
  to,
  state_id,
  city_id,
  bank_account_id,
) => {
  try {
    let url = `/payment/inward-payment/bank-reports?`;

    if (page) {
      url += `&page=${page}`;
    }

    if (per_page) {
      url += `&per_page=${per_page}`;
    }

    if (search) {
      url += `&term=${search}`;
    }

    if (name) {
      url += `&name=${name}`;
    }

    if (from) {
      url += `&from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    if (state_id) {
      url += `&state_id=${state_id}`;
    }

    if (city_id) {
      url += `&city_id=${city_id}`;
    }

    if (bank_account_id) {
      url += `&bank_account_id=${bank_account_id}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const getAllTransferData = async (page, per_page, search) => {
  try {
    let url = `/payment/transfer-payment`;

    if (page) {
      url += `?page=${page}`;
    }

    if (per_page) {
      url += `&per_page=${per_page}`;
    }

    if (search) {
      url += `&term=${search}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const InwardAccepted = async (data) => {
  try {
    return await postData(`/payment/inward-payment/accepted`, data);
  } catch (error) {
    console.error(error);
  }
};

export const InwardManual = async (data) => {
  try {
    return await postData(`/payment/inward-payment/manual`, data);
  } catch (error) {
    console.error(error);
  }
};

export const InwardEdit = async (data) => {
  try {
    return await postData(`/payment/inward-payment/edit`, data);
  } catch (error) {
    console.error(error);
  }
};

export const Delete = async (id) => {
  try {
    return await deleteData(`/payment/inward-payment/${id}`);
  } catch (error) {
    console.error(error);
  }
};
